<div class="filters-bar">
    @if (dashboardId && subscriptionState === 'Selected Widget') {
        <div class="selected-filters">
            <div class="filter-wrapper">
                <span class="filters-data">
                    <div class="icon-unsubscribed">
                        <ddv-unsubscribed-widget-icon></ddv-unsubscribed-widget-icon>
                    </div>
                    {{ (filters.length > 0 ? subscriptionState + ':' : noFiltersSelected) | uppercase }}
                </span>

                <div #addFiltersContainer class="filter-bubbles-container">
                    @for (filter of filters; track filter.name) {
                        <div
                            class="bubble-filter filter-focused"
                            [ngClass]="{'filter-disabled': !filter.value}"
                            (click)="showWidgetFilters = true"
                        >
                            {{ filter.value || filter.value === '' ? filter.name + ':' : filter.name }}
                            <strong>{{ filter.value === '' ? 'Blanks' : filter.value }}</strong>
                            <button class="remove-btn" (click)="removeFilter(filter)">&times;</button>
                        </div>
                    }
                </div>
            </div>

            <cc-icon
                id="view-filter"
                [icon]="'filter-plus'"
                [size]="'medium'"
                [title]="'Unsubscribed Widget Filter'"
                (iconClicked)="showWidgetFilters = true"
            >
            </cc-icon>
        </div>
    }

    @if (dashboardId && subscriptionState === 'All Subscribed') {
        <div class="subscribed-filter-wrapper">
            <cc-additional-filters
                title="View Filter"
                [direction]="'horizontal'"
                [size]="'fit-to-parent'"
                [addSearchValueAsOption]="true"
                [enableBlanksSelection]="true"
                [bubbleStyle]="true"
                [resolveFuzzyDatesAsFuzzy]="true"
                [fields]="filterAttributeList"
                [fuzzies]="ccFuzzyDates"
                [selected]="selectedFilterAttributes"
                (selectedChange)="onSelectedChange($event)"
            >
            </cc-additional-filters>
        </div>
    }
</div>

@if (showWidgetFilters) {
    <app-widget-filter
        [ccModal]="modalOptions"
        (dismissed)="showWidgetFilters = false"
        [widgetId]="selectedWidgetId"
        [isSubscribedToDashboardFilters]="false"
        [fuzzyDates]="fuzzyDates"
        [ccFuzzyDates]="ccFuzzyDates"
        [userPreferences]="userPreferences"
        [funds]="funds"
        [clients]="clients"
    >
    </app-widget-filter>
}
